import React, { useState, useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { ServerConfig } from 'config'
import axios from 'axios'
import { useSelector } from 'react-redux'

// @material-ui/core components
import { Typography } from '@material-ui/core'

import _, { get } from 'lodash'
import { makeStyles } from '@material-ui/core/styles'

import SortableTbl from "react-sort-search-table";

import EditComponent from './EditComponent.js'
import AddComponent from './AddComponent.js'

const useStyles = makeStyles((theme) => ({}))


const List = (props) => {
  const classes = useStyles()

  const auth = useSelector(state => state.auth)
  const [entries, setEntries] = useState([])

  const [cols, setCols] = useState(props.min_column_names)
  const [head, setHead] = useState(props.min_header_names)

  let list_get_url = props.list_get_url;
  let detail_get_url = props.detail_get_url;
  let detail_put_url = props.detail_put_url;
  let ledger_get_url = props.ledger_get_url;
  let add_new_url = props.add_new_url;
  let ledger_allow_entries = props.ledger_allow_entries;
  let show_machine_stats = props.show_machine_stats;

  let editable_fields = props.editable_fields;
  let non_editable_fields = props.non_editable_fields;

  /* check and update number of columns depending on screen-size */
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchListData = async () => {
      const config = { headers: { 'Content-Type': 'application/json' } }

      if (auth.access_token) {
        config.headers.Authorization = `Bearer ${auth.access_token}`
      }

      const results = await axios.get(list_get_url, config)

      for (var i in results.data) {
        for (const [key, value] of Object.entries(results.data[i])) {
          if (key == 'balance' || key == 'donated' || key == 'earned redemption' || key == 'withdrawn') {
            results.data[i][key] = '$' + (results.data[i][key] / 1e6);
          }
          console.log(key, value);
        }
      }
      setEntries(results.data)
    }

    fetchListData();

    window.addEventListener('customertable_is_dirty', fetchListData);

    return () => {
      window.removeEventListener('customertable_is_dirty', fetchListData);
    };

  }, [])

  useEffect(() => {
    if(screenSize.width > 1080){
      if(detail_get_url !== undefined){
        setCols(props.min_column_names.concat(props.optional_column_names).concat(["edit"]));
        setHead(props.min_header_names.concat(props.optional_header_names).concat([""]));
      }else{
        setCols(Array.prototype.concat(props.min_column_names, props.optional_column_names));
        setHead(Array.prototype.concat(props.min_header_names, props.optional_header_names));
      }
    }else{
      if(detail_get_url !== undefined){
        setCols(props.min_column_names.concat(["edit"]));
        setHead(props.min_header_names.concat([""]));
      }else{
        setCols(props.min_column_names);
        setHead(props.min_header_names);
      }
    }
  }, [screenSize.width])

  if (!auth.access_token) {
    return <Redirect to="/login" />
  }


  return (
    <>
      <Typography variant="h2" style={{'float':'left', 'marginTop': '5px'}}>
        {entries.length} Objects:
      </Typography>

      <SortableTbl
        paging={false}
        defaultCSS={false}
        tblData={entries}
        tHead={head}
        dKey={cols}
        customTd={[
          {
            custd: (tbldata) => {
              return <EditComponent
                detail_get_url={detail_get_url}
                detail_put_url={detail_put_url}
                rowData={tbldata.rowData}
                tdData={tbldata.tdData}
                editable_fields={editable_fields}
                non_editable_fields={non_editable_fields}
                ledger_get_url={ledger_get_url}
                ledger_allow_entries={ledger_allow_entries}
                show_machine_stats={show_machine_stats}
              />
            },
            keyItem: "edit"
          }
        ]}
        search={true}
      />

      {add_new_url !== undefined &&
          <AddComponent
            add_new_url={add_new_url}
            editable_fields={editable_fields}
          />
      }
    </>
  )
}

export default List
